export default __webpack_public_path__ + "static/media/circle-down.128f45c8.svg";